import Vue from 'vue'
import Vuex from 'vuex'

import * as notification from '@/store/modules/notification.js'
import * as mapStore from '@/store/modules/mapStore.js'
import * as connection from '@/store/modules/connection'
import * as surveillance from '@/store/modules/surveillance'
import * as motd  from '@/store/modules/motdHandler'

Vue.use(Vuex)
//export default
const store = new Vuex.Store({
  modules:{
  
    notification,
    mapStore,
    connection,
    surveillance,
    motd
    
   },
    // state: {},
    // mutations: {},
    // actions: {},
    // getters:{}
})

export default store